module.exports = __webpack_public_path__ + "static/media/AVIS_logo.c1e1fd24.svg";